// mediator.ts
type Callback<T> = (data: T) => void;

class Mediator {
  private events = new Map<string, Set<Callback<any>>>();
  private lastPublished = new Map<string, any>(); // <- armazena último valor

  subscribe<T>(event: string, callback: Callback<T>) {
    if (!this.events.has(event)) {
      this.events.set(event, new Set());
    }

    this.events.get(event)!.add(callback);

    // Se já foi publicado antes, chama o callback imediatamente
    if (this.lastPublished.has(event)) {
      callback(this.lastPublished.get(event));
    }
  }

  unsubscribe<T>(event: string, callback: Callback<T>) {
    this.events.get(event)?.delete(callback);
  }

  publish<T>(event: string, data: T) {
    this.lastPublished.set(event, data); // salva o último valor
    this.events.get(event)?.forEach(cb => cb(data));
  }
}

export const mediator = new Mediator();
